var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"color":"red"},on:{"click":_vm.change}},[_vm._v("mdi-help-circle")])
}
var staticRenderFns = []

export { render, staticRenderFns }